import { TemplateElement } from '@webtides/element-js';

import styles from './dropdown.css';
import DropDownEvents from './DropDownEvents';

import template from './dropdown.template';

export default class Dropdown extends TemplateElement {
    constructor(options) {
        super({ shadowRender: false, styles: [styles], ...options });
    }

    properties() {
        return {
            options: [
                { value: 0, label: 'Default' },
                { value: 1, label: 'Hover' },
                { value: 2, label: 'Active', selected: true },
                { value: 3, label: 'Focus' },
            ],
            type: '',
            open: false,
            disabled: false,
            required: false,
            defaultOptionOverride: null,
        };
    }

    connected() {
        super.connected();
        this.addEventListeners();
    }

    addEventListeners() {
        document.addEventListener('click', this.onClick.bind(this));
    }

    onClick(e) {
        if (!this.contains(e.target)) {
            this.open = false;
        } else {
            e.preventDefault();
        }
    }

    updateSelected(value) {
        this.options = this.options.map((option) => Object.assign(option, { selected: value === option.value }));
        this.dispatch(DropDownEvents.CHANGE_OPTION, this.selectedOption, true);
        this.requestUpdate();
    }

    events() {
        return {
            '[data-open]': {
                click: (ev) => {
                    this.open = !this.open;
                },
            },
            '[data-value]': {
                click: (ev) => {
                    const value = ev.target.dataset.value;
                    this.updateSelected(value);
                },
            },
            select: {
                change: (ev) => {
                    const value = ev.target.value;
                    this.updateSelected(value);
                },
            },
        };
    }

    get selectedOption() {
        const selectedOption = this.options.find((option) => option.selected);

        if (!selectedOption) {
            return this.defaultOption;
        }

        return { ...selectedOption, type: this.type };
    }
    get defaultOption() {
        if (this.defaultOptionOverride) {
            return this.defaultOptionOverride;
        }
        const defaultOption = this.options.find((option) => option.default);

        if (!defaultOption) {
            return this.options[0];
        }

        return defaultOption;
    }
    get value() {
        return this.selectedOption.value;
    }

    template() {
        return template(this);
    }
}
